import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import {
	camera,
	cancle,
	chatcurve,
	chatcurve1,
	enterchat,
	file,
	uploadfile,
	userpatient,
} from "../Constant/Index";

const PhysicianCurrentChat = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Chat" />
			<section className="chat">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="main-profile-content radius-20 ">
								<div className="border-bottom-chat">
									<div className="row justify-content-between align-items-center p-4">
										<div class="col-lg-4">
											<div className="d-flex gap-3 align-items-center">
												<img src={userpatient} className="img-fluid" alt="" />
												<div>
													<h4 class="main-heading-font mb-0 level-6 ">
														Jon Doe
													</h4>
													<h5 class="primary-medium-font mb-0 level-8 extra-color-15">
														4 mins ago
													</h5>
												</div>
											</div>
										</div>
										<div className="col-lg-8">
											<div class="row mt-2">
												<div className="col-lg-12">
													<div className="row">
														<div className="col-lg-4">
															<Link
																class="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
																to="/"
															>
																<span class="bg-wrapper w-100">
																	{" "}
																	<img
																		src={file}
																		className="img-fluid pe-3"
																		alt=""
																	/>{" "}
																	View Notes{" "}
																</span>
															</Link>
														</div>
														<div className="col-lg-4">
															<Link
																class="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
																to="/physician-prescription"
															>
																<span class="bg-wrapper w-100">
																	<img
																		src={file}
																		className="img-fluid pe-3"
																		alt=""
																	/>
																	View Prescription
																</span>
															</Link>
														</div>
														<div className="col-lg-2">
															<div className="d-flex align-items-center justify-content-center">
																<div class="edit-btn chat-user">
																	<Link to="/physician-video-call">
																		<div className="nav-anchor">
																			<img
																				src={camera}
																				className="img-fluid"
																				alt=""
																			/>
																		</div>
																	</Link>
																</div>
															</div>
														</div>
														<div className="col-lg-2">
															<div className="d-flex align-items-center justify-content-center">
																<div class="edit-btn chat-user">
																	<Link to="/physician-Past-detail">
																		<div className="nav-anchor">
																			<img
																				src={cancle}
																				className="img-fluid"
																				alt=""
																			/>
																		</div>
																	</Link>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="chat-main p-4">
									<div className="main-physician-massage">
										<div className="physician-massage">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipicing elit,
												sed do eiusmod tempor incididunt ut labore et dolore
												magna aliqua Lorem amet.
											</p>
											<h4>4 mins ago</h4>
											<div className="chat-curve-img-left">
												<img src={chatcurve} className="img-fluid" alt="" />
											</div>
										</div>
									</div>
									<div className="main-user-massage">
										<div className="user-massage">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipicing elit,
												sed do eiusmod tempor incidunt.
											</p>
											<h4>4 mins ago</h4>
											<div className="chat-curve-img-right">
												<img src={chatcurve1} className="img-fluid" alt="" />
											</div>
										</div>
									</div>
									<div className="main-physician-massage">
										<div className="physician-massage">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipicing elit,
												sed do eiusmod tempor incididunt ut labore et dolore
												magna aliqua Lorem amet.
											</p>
											<h4>4 mins ago</h4>
											<div className="chat-curve-img-left">
												<img src={chatcurve} className="img-fluid" alt="" />
											</div>
										</div>
									</div>
									<div className="main-user-massage">
										<div className="user-massage">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipicing elit,
												sed do eiusmod tempor incidunt.
											</p>
											<h4>4 mins ago</h4>
											<div className="chat-curve-img-right">
												<img src={chatcurve1} className="img-fluid" alt="" />
											</div>
										</div>
									</div>
									<div className="main-physician-massage">
										<div className="physician-massage">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipicing elit,
												sed do eiusmod tempor incididunt ut labore et dolore
												magna aliqua Lorem amet.
											</p>
											<h4>4 mins ago</h4>
											<div className="chat-curve-img-left">
												<img src={chatcurve} className="img-fluid" alt="" />
											</div>
										</div>
									</div>
									<div className="main-user-massage">
										<div className="user-massage">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipicing elit,
												sed do eiusmod tempor incidunt.
											</p>
											<h4>4 mins ago</h4>
											<div className="chat-curve-img-right">
												<img src={chatcurve1} className="img-fluid" alt="" />
											</div>
										</div>
									</div>
									<div className="main-physician-massage">
										<div className="physician-massage">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipicing elit,
												sed do eiusmod tempor incididunt ut labore et dolore
												magna aliqua Lorem amet.
											</p>
											<h4>4 mins ago</h4>
											<div className="chat-curve-img-left">
												<img src={chatcurve} className="img-fluid" alt="" />
											</div>
										</div>
									</div>
									<div className="main-user-massage">
										<div className="user-massage">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipicing elit,
												sed do eiusmod tempor incidunt.
											</p>
											<h4>4 mins ago</h4>
											<div className="chat-curve-img-right">
												<img src={chatcurve1} className="img-fluid" alt="" />
											</div>
										</div>
									</div>
								</div>
								<div className="chat-input">
									<div className="row align-items-center">
										<div className="col-lg-10">
											<div className="form-group">
												<textarea
													placeholder="Write Your Message"
													name=""
													id=""
												></textarea>
											</div>
										</div>
										<div className="col-lg-1">
											<div className="file-upload text-end">
												<img src={uploadfile} alt="" className="img-fluid" />
											</div>
										</div>
										<div className="col-lg-1">
											<div className="file-upload">
												<img src={enterchat} alt="" className="img-fluid" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianCurrentChat;
